//Node imports
import { Parser, EventConstants } from "@quest/platform-murka/dist";
import { IParamsData, ILines, IGetBetResultData, IResponseInit, PlatformConstantsLeander } from "@quest/oddsworks-platform/dist";
import { ingenuity, dispatcher, IEvent, IObject, clone } from "@quest/base-core";
import { EventConstants as PlatformEventConstants } from "@quest/platform-core";
import { EventConstantsLeander } from "@quest/oddsworks-platform/dist";

//Class imports
import { GameParserModel } from "./GameParserModel";
import { PlatformConstantsGame } from "../Constants/PlatformConstantsGame";
import { gameConstants } from "../Constants/gameConstants";
import { eventDispatchers } from "../Constants/EventDispatchers";

export class GameParser extends Parser {
  protected model: GameParserModel;
  private potPositions: number[][] = [];
  private potPositionsFG: number[][] = [];
  private JACKPOT_GRAND_STR: string = "jackpot_grand";

  // Override to convert initial reel grid in 8X5
  protected processGameParameters(params: any) {
    super.processGameParameters(params);
    this.model.setCurrentBetIndex(this.model.getBetPerLine().indexOf(this.model.getCurrentBet()));
    this.model.setJackpotMultipliers(params.jackpotMultipliers);
  }


  // Override to convert reel grid in 8X5
  protected processParameters(params: IParamsData): void {
    super.processParameters(params);
    (ingenuity.parserModel as GameParserModel).setTotalBaseGameWinAmt(0);
        (ingenuity.parserModel as GameParserModel).setPrizePotCredit(0);
        (ingenuity.parserModel as GameParserModel).setGrandJackpotWonBG(0);
        (ingenuity.parserModel as GameParserModel).setMajorJackpotWonBG(0);
        (ingenuity.parserModel as GameParserModel).setMinorJackpotWonBG(0);
        (ingenuity.parserModel as GameParserModel).setMiniJackpotWonBG(0);
    this.model.setTotalLineWin(0);
    this.model.setGameWinAmt(0);
    this.model.setTotalWin(params.creditsWon);
    this.parseFreeSpinSymbolOffsets();
    this.processTriggerScatterWin(params);
    this.processBonusInfo(params.bonusInfo);
    if (ingenuity.configData.isBrokenGame) {
      this.model.setTriggerReelGrid(this.model.getReelGrid());
    }
    this.checForStackSyminReelGrid();
    if(ingenuity.configData.isBrokenGame && !(ingenuity.parserModel as GameParserModel).getIsFreeSpintriggered()){
      this.model.setGameWinAmt(params.creditsWon);
    } else {
      this.model.setGameWinAmt(this.model.getBaseGameWinAmt());
    }
    params.winningLines && this.model.setTotalLineWin(params.winningLines.creditsWon);
  }

  /**
    * Method processBonusInfo overrrided to parse game end data.
    * @param response 
    */
  protected processBonusInfo(response?: any[]): void {
    this.model.setBonusInfo(response);
    response.length && response.forEach((data) => {
      if (data.bonusName === ingenuity.configData.freeSpinsBonusName || data.bonusName === ingenuity.configData.freeSpinsFromPotion) {
        this.parseFreeSpin(data);
      }
      if (data.bonusName === ingenuity.configData.ReplaceMysterySymbol) {
        this.storeMysterySymbol(data)
      }
      else if (data.bonusName === ingenuity.configData.BaseGameSelectReels) {
        this.updateNewReelSet(data)
      } 
      else if (data.bonusName === ingenuity.configData.FreespinRetrigger) {
        this.processRetriggerData(data);
      }
      else if (data.bonusName === ingenuity.configData.magicPotionPaidSpin) {
        this.parseJackpotDataBG(data);
      }
      else if (data.bonusName === ingenuity.configData.jackPotPaidSpin) {
        this.parsejackPotWonDataBG(data);
      }
      else if (data.bonusName === ingenuity.configData.MagicPotionFreeSpin) {
        this.parseJackpotData(data);
      }
      else if (data.bonusName === ingenuity.configData.awardJackpots) {
        this.awardJackpots(data);
      }

    });
  }

  /**
   * function is used to update basegame and freegame reelset whenever a new reel available in response
   */
  private updateNewReelSet(data: any): void {
    const reelSet:string=data.reelSelected;
    if(reelSet.includes("base") ){
      const newBaseReelSet: number[][] = clone(this.model.getAllReelSet(reelSet));
      this.model.setBaseReel(this.changeSymNumber(newBaseReelSet));
    }
    else if(reelSet.includes("free")){
      this.model.setFreeSpinReel(this.changeSymNumber(clone(this.model.getAllReelSet(reelSet))));
      dispatcher.fireEvent(eventDispatchers.UDPATE_NEW_FG_REELSET);
    }   
  }

  //store mystery symbol
  private storeMysterySymbol(data: any): void {
    this.model.setRevealSymNum(data.mysterySymbol);
    dispatcher.fireEvent(eventDispatchers.UDPATE_NEW_REELSET);
  }

  // Override to set free spin data
  protected parseFreeSpin(response: any): void {
    this.model.setHasFreeGamesWin(false);
    this.model.setIsFreeSpintriggered(false);
    super.parseFreeSpin(response);
    this.model.setIsFreeSpintriggered(true);

  }

   /**
    * Method parseNextFreeSpinData overrrided to parser data for next spin during FG
    * @param evt 
    */
  protected parseNextFreeSpinData(evt: IEvent): void {
    (ingenuity.parserModel as GameParserModel).setRetriggerWithExtraSpin(false);
    this.model.setTotalLineWin(0);
    const freeSpinData: IObject = this.model.getFreeGameResponse()[this.model.getCurrentFreeSpinCount()][0];
    super.parseNextFreeSpinData(evt);
    this.parseFreeSpinSymbolOffsets();
    this.processTriggerScatterWin(freeSpinData);
    this.checForStackSyminReelGridFG();
    this.model.setFSCurrentSpinWin(freeSpinData.creditsWonAccumulated);

    freeSpinData.winningLines && this.model.setTotalLineWin(freeSpinData.winningLines.creditsWon);
  }

  //check if stack is present in reelgrid
  private checForStackSyminReelGridFG(): void {
    const reelGrid = this.model.getReelGrid();
    const minValueForStack : number =1;
    let stackSymoffsetFG: number[][] = [];
    let numberOfSingleStackSymbol: number = 0;
    for (let i: number = 0; i < reelGrid.length; i++) {
      numberOfSingleStackSymbol = 0;
      for (let j: number = 0; j < reelGrid[i].length; j++) {
        if (reelGrid[i][j] === 1) {
          numberOfSingleStackSymbol++;
          const pos: number[] = [i, j];
          stackSymoffsetFG.push(pos);
          if (numberOfSingleStackSymbol > minValueForStack) {
            this.model.setStackSymPresentFG(true);
          }
        }
        else {
          if (stackSymoffsetFG.length != 0 && numberOfSingleStackSymbol >= minValueForStack) {
            break;
          }
        }
      }

    }
    this.model.setStackSymOffsetsFG(stackSymoffsetFG);
  }

  
  /**
    * Method parseJackpotDataBG parse jackpot data for basegame
    * @param data 
    */
  private parseJackpotDataBG(data: IObject): void {
    this.model.setIsMagicPotionBG(false);
    this.model.setPotionJackpotPositionsBG([]);
    this.model.setPotionPointPositionsBG([]);
    this.model.setNumberOfPotsBG(0);
    this.model.setPrizePotCredit(0);
    if (data.numberOfPotions != 0) {
      this.model.setIsMagicPotionBG(true);
      this.model.setNumberOfPotsBG(data.numberOfPotions);
      this.model.setPrizePotCredit(data.creditsWon);
      this.model.setPotionJackpotPositionsBG(data.potionJackpotPositions);
      this.model.setPotionPointPositionsBG(data.potionPointPositions);
      this.checkForFSPotSymbol(data);
    }
    this.parseMotionPotOffsets();
  }

  //Method is use to store offsets of pots landed
  private parseMotionPotOffsets(): void {
    this.potPositions = [];
    const reelGrid: number[][] = this.model.getReelGrid();
    for (let i: number = 0; i < reelGrid.length; i++) {
      for (let j: number = 0; j < reelGrid[i].length; j++) {
        if (reelGrid[i][j] === 13) {
          this.potPositions.push([i, j])
        }
      }
    }
    this.model.setMotionPotOffsets(this.potPositions);
  }

   /**
    * Method checkForFSPotSymbol check if scatter pot symbol is present
    * @param data 
    */
  private checkForFSPotSymbol(data: IObject): void {
    let Jackpot = data.potionJackpotPositions;
    Jackpot && Jackpot.length && Jackpot.forEach((element: IObject) => {

      // Accessing position and type of Jackpot using Object.entries()
      const entries = Object.entries(element);

      // Iterating over the entries array
      for (let [position, Jackpot] of entries) {
        console.log(position);
        if (Jackpot === "fs") {
          this.model.setIsFSPotPresentBG(true);
        }
      }
    });

  }

    /**
    * Method parsejackPotWonDataBG parse jackpot won data for base game
    * @param data 
    */
  private parsejackPotWonDataBG(data: IObject): void {
    this.model.setIsJackpotWonBG(false);
    this.model.setJackpotWonBG({});
    if (data.numberOfJackpots) {
      this.model.setIsJackpotWonBG(true);
      this.model.setJackpotWonBG(data.jackpotWon);
      data.grandCredits > 0 && this.model.setGrandJackpotWonBG(data.grandCredits);
      data.majorCredits > 0 && this.model.setMajorJackpotWonBG(data.majorCredits);
      data.minorCredits > 0 && this.model.setMinorJackpotWonBG(data.minorCredits);
      data.miniCredits > 0 && this.model.setMiniJackpotWonBG(data.miniCredits);

    }
  }

  //parse jackpot data for every spin
  private parseJackpotData(data: IObject): void {
    this.model.setjackpotMultipliersFG({});
    this.model.setPotionPointPositionsFG([]);
    this.model.setPotionJackpotPositionsFG([]);
    this.model.setPrizePotCreditFG(0);
    this.model.setIsMagicPotionFG(false);
    this.model.setTotalCapsuleCount({});
    if (data.numberOfPotions && data.numberOfPotions != 0) {
      this.model.setIsMagicPotionFG(true);
      this.model.setPotionPointPositionsFG(data.potionPointPositions);
      this.model.setPotionJackpotPositionsFG(data.potionJackpotPositions);
      this.model.setPrizePotCreditFG(data.creditsWon);
      this.model.setTotalCapsuleCount(data.jackpotMeters);
      this.model.setAwardJackpotsFG(data.alteredJackpots);
    } else {
      //This data is needed during broken when no pots are landed on reelgrid
      data.jackpotMeters && this.model.setTotalCapsuleCount(data.jackpotMeters);
      data.alteredJackpots && this.model.setAwardJackpotsFG(data.alteredJackpots);

    }

    // Parsing Retrigger with Extra spins
    if (data.extraSpins && data.extraSpins > 0) {
      this.processRetriggerData(data);
      (ingenuity.parserModel as GameParserModel).setRetriggerWithExtraSpin(true);
    }
    this.parseMotionPotOffsetsFG();
    this.model.setjackpotMultipliersFG(data.alteredJackpots);
    this.model.setTotalJackpotWinFG(0);
  }

  //Method is use to store offsets of pots landed in FG
  private parseMotionPotOffsetsFG(): void {
    this.potPositionsFG = [];
    const reelGrid: number[][] = this.model.getReelGrid();
    for (let i: number = 0; i < reelGrid.length; i++) {
      for (let j: number = 0; j < reelGrid[i].length; j++) {
        if (reelGrid[i][j] === 13) {
          this.potPositionsFG.push([i, j])
        }
      }
    }
    this.model.setMotionPotOffsetsFG(this.potPositionsFG);
  }

   /**
    * Method awardJackpots set data for jackpots
    * @param data 
    */
    private awardJackpots(data: IObject): void {
      this.resetJackpotValues();
      const winJackpotMeters: IObject = data.jackpotMeters;
      this.updateJackpotAward(winJackpotMeters);
      this.updateJackpotValues(data);
    }

    // Reset all jackpot-related values in the model
    private resetJackpotValues(): void {
      this.model.setGrandJackpotWinFG(0);
      this.model.setIsJackpotAward(false);
      this.model.setIsGrandJackpotAward(false);
      this.model.setGrandJackpotPrizeFG(0);
      this.model.setMajorJackpotPrizeFG(0);
      this.model.setMinorJackpotPrizeFG(0);
      this.model.setMiniJackpotPrizeFG(0);
      this.model.setTotalJackpotWinFG(0);
    }

    // check which jackpots have been won and model value
    private updateJackpotAward(winJackpotMeters: IObject): void {
      for (const key in winJackpotMeters) {
        if (winJackpotMeters[key] >= 3) {
          this.model.setIsJackpotAward(true);
        }
        if ((key === this.JACKPOT_GRAND_STR) && (winJackpotMeters[key] >= 3)) {
          this.model.setIsGrandJackpotAward(true);
        }
      }
    }

    // Update jackpot prize values during FG
    private updateJackpotValues(data: IObject): void {
      if (this.model.getIsJackpotAward()) {
        this.model.setGrandJackpotWinFG(data.grandCredits);
      }
      data.grandCredits && this.model.setGrandJackpotPrizeFG(data.grandCredits);
      data.majorCredits && this.model.setMajorJackpotPrizeFG(data.majorCredits);
      data.minorCredits && this.model.setMinorJackpotPrizeFG(data.minorCredits);
      data.miniCredits && this.model.setMiniJackpotPrizeFG(data.miniCredits);
      data.creditsWon && this.model.setTotalJackpotWinFG(data.creditsWon);
    }


    /**
    * Method parseBrokenFreeGameData overrrided to parser broken data during FG
    */
  protected parseBrokenFreeGameData(): void {
    const data = this.model.getFreeGameResponse()[this.model.getCurrentFreeSpinCount()][0];
    super.parseBrokenFreeGameData();
    this.model.setTotalLineWin(data.creditsWon);
    this.parseFreeSpinSymbolOffsets();

    this.processTriggerScatterWin(data);

    this.checForStackSyminReelGridFG();
    this.model.setFSCurrentSpinWin(data.creditsWonAccumulated);
  }

    /**
    * Method processGetBetResult overrrided to handle functionality during insufficient fund
    * @param betResultData
    */
  protected processGetBetResult(betResultData: IGetBetResultData): void {
    betResultData.balance && this.model.setBalance(betResultData.balance);
    betResultData.freeBalance && this.model.setFreeBalance(betResultData.freeBalance);
    betResultData.freePlaysData && this.model.setFreePlaysData(betResultData.freePlaysData);
    betResultData.params && this.processParameters(betResultData.params[0]);
    betResultData.playingFreePlay && this.model.setIsPlayingFreePlay(betResultData.playingFreePlay);
    dispatcher.fireEvent(EventConstants.UPDATE_CREDIT_VALUE);
  }

  /**
  * Method parseFreeSpinSymbolOffsets to parse scatter symbols.
  */
  private parseFreeSpinSymbolOffsets(): void {
    const reelGrid: number[][] = this.model.getReelGrid();
    const symbolPositionArray: number[][] = [];
    const symbolPositionNormalArray: number[][] = [];
    for (let i: number = 0; i < reelGrid.length; i++) {
      for (let j: number = 0; j < reelGrid[i].length; j++) {
        const symbolNumber: number = reelGrid[i][j]
        if (symbolNumber === (gameConstants.FREE_SPIN_SYMBOL)) {
          symbolPositionArray.push([i, j]);
          symbolPositionNormalArray.push([i, j])
        }
      }
    }
    this.model.setFreeSymNormalOffsets(this.sortArrayByFirstElement(symbolPositionNormalArray));

  }

  /**
   * Method processTriggerScatterWin overrided to parse game end data.
   * @param response 
   */
  protected processTriggerScatterWin(response: any): void {
    this.model.getTriggerScatterWinData().length = 0;
    //  overrided to add scatter symbol number 12 and 13.
    const winScatter: any = {
      id: 0,
      no: gameConstants.FREE_SPIN_SYMBOL,
      win: response.creditsWon ? response.creditsWon : 0,
      positions: this.model.getFreeSymNormalOffsets(),
      winSymLen: this.model.getFreeSymNormalOffsets().length,
    }
    this.model.getFreeSymNormalOffsets().length >= 3 && this.model.setTriggerScatterWinData([winScatter]);
    this.model.getTriggerScatterWinData.length > 0 && this.model.setHasScatterWins(true);
  }

  /**
   * Method sortArrayByFirstElement to short scatter symbols array via 1st index.
   * @param arr 
   * @returns 
   */
  private sortArrayByFirstElement(arr: number[][]): number[][] {
    return arr.sort((a, b) => a[0] - b[0]);
  }

  // Override to update reel set value based on monkey symbol
  protected processReelsData(reelsData: any): void {
    this.model.setAllReelSet(reelsData);
    this.model.setBaseReel(this.changeSymNumber(reelsData[PlatformConstantsGame.BASE_GAME_REELSET]));
    this.model.setFreeSpinReel(this.changeSymNumber(reelsData[PlatformConstantsGame.FREE_GAME_REELSET]));
  }


  // Override to update win lines offset position based on 8X5 grid
  protected processLinesData(data: ILines[]): void {
    super.processLinesData(data);
    this.model.setWinLinesData(this.model.getWinLinesData());
        if (!data.length) {
      this.model.setWinLinesData([]);
      this.model.setHasLineWins(false);
    }
  }

   /**
   * Method processWinningLines oveeride to set credits won
   * @param winningLinesData 
   */
  public processWinningLines(winningLinesData: any) {
    this.model.setWinLineAmount(0);
    super.processWinningLines(winningLinesData);
    this.model.setWinLineAmount(winningLinesData.creditsWon);
    this.model.setBaseGameWinAmt(winningLinesData.creditsWon);
  }

  /**
   * Method processGameAfterError oveeride to reset balance during insufficient funds
   */
  protected processGameAfterError(): void {
    this.model.setNoSettleOnError(true);
    ingenuity.parserModel.setBalance(ingenuity.parserModel.getUserBalance());
    this.model.setFreeBalance(this.model.getUserBalance());
    dispatcher.fireEvent(EventConstants.UPDATE_CREDIT_VALUE, { value: this.model.getBalance() });
    dispatcher.fireEvent(PlatformEventConstants.SPIN_RESPONSE_PROCESSED);
  }

  /**
 * processRetriggerData method overrided to update game feature response 
 * @param response 
 */
  protected processRetriggerData(response: any): void {
    this.model.setIsFreeSpinRetriggered(true);
    this.model.setRetriggerFreeSpins(response.extraSpins);
    if (!this.model.getFreeGameBroken()) {
      this.model.setFreeSpinsRemaining(this.model.getFreeSpinsRemaining() + response.extraSpins);  // tag name update from  fresSpinRetriger --> retriggerCount
      this.model.setFreeSpinNum(this.model.getFreeSpinNum() + response.extraSpins);
    }
  }


  /**
   * override to change 200 symbol number into 11 , and 101 into 12
   */
  protected updateReelGrid(grid: number[]): number[][] {
    let updatedSymbolGrid: number[] = this.changeSymNumber(grid);
    return super.updateReelGrid(updatedSymbolGrid);
  }

  /**
     * function will convert symbol number 150 into 13, 110 into 12, and 77 into reveal
     */
  private changeSymNumber(grid: number[] | number[][]): any {
    grid.forEach((element: any, index: number) => {
      if (Array.isArray(element)) {
        element.forEach((position: number, index: number) => {
          if (position === 150) {
            element[index] =gameConstants.POT_SYMBOL;
          } else if (position === 110) {
            element[index] = gameConstants.FREE_SPIN_SYMBOL;
          } else if (position === 77) {
            element[index] = this.model.getRevealSymNum();
          }
        });
      } else {
        if (element === 150) {
          grid[index] =gameConstants.POT_SYMBOL;
        } else if (element === 110) {
          grid[index] = gameConstants.FREE_SPIN_SYMBOL;
        } else if (element === 77) {
          grid[index] = this.model.getRevealSymNum();
        }
      }
    });
    return grid;
  }
  //check if stack is present in reelgrid
  private checForStackSyminReelGrid(): void {
    const reelGrid: number[][] = this.model.getReelGrid();
    let stackSymoffset: number[][] = [];
    let numberOfSingleStackSymbol: number = 0;
    for (let i: number = 0; i < reelGrid.length; i++) {
      numberOfSingleStackSymbol = 0;
      for (let j: number = 0; j < reelGrid[i].length; j++) {
        if (reelGrid[i][j] === 1) {
          numberOfSingleStackSymbol++;
          const pos: number[] = [i, j];
          stackSymoffset.push(pos);
          if (numberOfSingleStackSymbol > 1) {
            this.model.setStackSymPresent(true);
          }
        }
        else {
          if (stackSymoffset.length != 0 && numberOfSingleStackSymbol >= 1) {
            break;
          }
        }
      }
    }
    this.model.setStackSymOffsets(stackSymoffset);
  }

  /**
     * Methor overrided to reset freegame broken data if not reset before broken
     */
  protected parseInitResponse(response: IResponseInit): void {
      this.processInitialConfigs(response);
      this.processBalance(response);
      // change order to handal broken persing
      this.processGameParameters(response.params);
      if (response.params.responseHistory) {
        this.processBrokenGameData(response.data);
        dispatcher.fireEvent(EventConstantsLeander.GAME_STATUS_UPDATED, PlatformConstantsLeander.OPEN_PLAY);
      }
      else if (response.data.brokenData && response.data.brokenData.data.CurrentCount > 0) {
        dispatcher.fireEvent(EventConstantsLeander.SAVE_DATA_REQUEST, this.model.getUserGameCloseData());
      }
      this.openGameProcessed();
  }
  // Overrided to send init wrapper call after initialize broken game
  protected openGameProcessed(): void {
    if (ingenuity.configData.isBrokenGame) {
      this.model.getFreeGameBroken() && this.parseBrokenFreeGameData();
      dispatcher.fireEvent(EventConstants.INITIATE_BROKEN_GAME);
      dispatcher.fireEvent(EventConstants.ERROR_FOR_BROKEN);
    } else {
      dispatcher.fireEvent(PlatformEventConstants.OPEN_GAME_PROCESSED);
    }
    dispatcher.fireEvent(EventConstantsLeander.SEND_INIT_WRAPPER);
  }
}